export const FiltersOption = [
  { label: "MTD", value: 1 },
  { label: "Last Month", value: 2 },
  { label: "Last 3 months", value: 3 },
  { label: "YTD", value: 4 },
  { label: "Last Year", value: 5 },
  { label: "ALL", value: 6 },
];

export const ContractTypeOptions = [
  { key: 1, name: "Fleet Customers" },
  { key: 2, name: "Lease Customers" },
  { key: 3, name: "Other Customers" },
];

export const DEFAULT_CONTRACT_TYPES = [1];

export const buildContractTypeQuery = (types) => {
  const values =
    Array.isArray(types) && types.length ? types : DEFAULT_CONTRACT_TYPES;
  return values.map((type) => `contractType=${type}`).join("&");
};
